import React from 'react';
import '../../../../assests/css/customer/Footer/Terms.css';
import MyNavbar from '../../Mynavbar/MyNavbar';
import Footer from '../Footer';
import PageTemplate from './PageTemplate';

const Terms = () => {
  return (
    <>
      <MyNavbar />
      <br />
      <br />
      <br />
      
      <PageTemplate title="Terms & Conditions">
        <section className="terms-section">
          <h2>Terms of Service</h2>
          <p>
            Welcome to Moonlit. By accessing or using our website and services, you agree to be bound by these Terms and Conditions. Please read them carefully before proceeding. If you do not agree with any part of these terms, you should discontinue use of our platform immediately.
          </p>

          <h3>1. Acceptance of Terms</h3>
          <p>
            By creating an account, placing an order, or browsing our website, you acknowledge that you have read, understood, and agree to comply with these Terms and Conditions, as well as our Privacy Policy. These terms apply to all visitors, users, and customers of moonlit.pk.
          </p>

          <h3>2. Use of Website</h3>
          <p>
            You agree to use our website only for lawful purposes and in a manner that does not infringe upon the rights of others or restrict their use of the site. Prohibited activities include, but are not limited to: distributing malicious software, attempting unauthorized access to our systems, engaging in fraudulent transactions, or using automated tools to scrape content.
          </p>

          <h3>3. Account Responsibility</h3>
          <p>
            When you create an account with Moonlit, you are responsible for maintaining the confidentiality of your login credentials and for all activities that occur under your account. You must notify us immediately of any unauthorized use of your account or any security breach. Moonlit is not liable for any loss or damage arising from your failure to protect your account information.
          </p>

          <h3>4. Product Information & Pricing</h3>
          <p>
            We strive to ensure that all product descriptions, images, and prices displayed on our website are accurate. However, we do not warrant that product descriptions or other content is error-free. In the event of a pricing error, we reserve the right to cancel or refuse any order placed at the incorrect price.
          </p>

          <h3>5. Orders & Payments</h3>
          <p>
            All orders are subject to availability and acceptance by Moonlit. We reserve the right to refuse or cancel any order for reasons including product unavailability, pricing errors, or suspected fraudulent activity. Payment must be made in full at the time of purchase unless otherwise specified. We accept payment via Cash on Delivery (COD) and online payment methods as outlined in our Payment Policy.
          </p>

          <h3>6. Shipping & Delivery</h3>
          <p>
            We aim to process and ship orders promptly. Delivery times are estimates and may vary based on your location and courier service performance. Moonlit is not responsible for delays caused by third-party shipping providers, customs clearance, or circumstances beyond our control such as natural disasters or public holidays.
          </p>

          <h3>7. Returns, Exchanges & Refunds</h3>
          <p>
            Our return and refund policies are outlined separately and form part of these Terms and Conditions. By placing an order, you agree to abide by our return policy, which includes specific conditions and timelines for returns and exchanges. Please review our Returns & Refunds Policy for detailed information.
          </p>

          <h3>8. Intellectual Property Rights</h3>
          <p>
            All content on moonlit.pk, including text, graphics, logos, images, product descriptions, and software, is the exclusive property of Moonlit or its content suppliers and is protected by copyright, trademark, and other intellectual property laws. You may not reproduce, distribute, modify, or create derivative works from any content without our express written permission.
          </p>

          <h3>9. Limitation of Liability</h3>
          <p>
            To the fullest extent permitted by law, Moonlit shall not be liable for any indirect, incidental, consequential, or punitive damages arising from your use of our website or services. This includes, but is not limited to, loss of profits, data, or business opportunities. Our total liability in any matter arising from these Terms shall not exceed the amount paid by you for the product or service in question.
          </p>

          <h3>10. Indemnification</h3>
          <p>
            You agree to indemnify, defend, and hold harmless Moonlit, its affiliates, employees, and partners from any claims, damages, liabilities, or expenses (including legal fees) arising from your use of our website, violation of these Terms, or infringement of any third-party rights.
          </p>

          <h3>11. Modification of Terms</h3>
          <p>
            Moonlit reserves the right to update or modify these Terms and Conditions at any time without prior notice. Any changes will be effective immediately upon posting on this page. Your continued use of our website after such changes constitutes your acceptance of the revised terms. We encourage you to review this page periodically.
          </p>

          <h3>12. Governing Law & Dispute Resolution</h3>
          <p>
            These Terms and Conditions are governed by and construed in accordance with the laws of Pakistan. Any disputes arising from these terms or your use of our services shall be resolved through binding arbitration or in the courts of Pakistan, as applicable.
          </p>

          <h3>13. Contact Information</h3>
          <p>
            If you have any questions, concerns, or feedback regarding these Terms and Conditions, please contact our customer support team. We are here to assist you and ensure a positive experience with Moonlit.
          </p>
        </section>
      </PageTemplate>
      
      <Footer />
    </>
  );
};

export default Terms;